import { EnvConfig } from '@/env_config';

export const isProdEnv = (): boolean => EnvConfig.calmEnv === 'prod';

/**
 * Prefixed outside production so the environment is identifiable from the browser tab alone, where
 * several portal tabs are often open side by side. Both routers set the document title separately,
 * so this keeps them in step.
 */
export const getPageTitle = (): string => (isProdEnv() ? 'Calm Partner Portal' : '[DEV] Calm Partner Portal');

/**
 * The dev icon is the black Calm mark, distinguishable from the production blue at tab size.
 * Set in both routers, which declare their icons separately.
 */
export const getFaviconPath = (): string => (isProdEnv() ? '/_n/favicon.ico' : '/_n/favicon-dev.ico');
